var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCreated = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 18,
  viewBox: "0 0 8 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 6C1 5.44772 1.44772 5 2 5C2.55228 5 3 5.44772 3 6V12C3 12.5523 2.55228 13 2 13C1.44772 13 1 12.5523 1 12V6Z",
  fill: "#C8B5DF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 6C5 5.44772 5.44772 5 6 5C6.55228 5 7 5.44772 7 6V12C7 12.5523 6.55228 13 6 13C5.44772 13 5 12.5523 5 12V6Z",
  fill: "#C8B5DF"
})));
export { SvgCreated as ReactComponent };
export default __webpack_public_path__ + "assets/icons/created.89f58b.svg";